import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { offset, flip, shift } from '@floating-ui/dom';

const tooltipMiddlewares = [
  offset(10),
  flip({ fallbackPlacements: ['top-end'] }),
  shift({ padding: 5 }),
];
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

export default function Tooltip(props) {
  const {
    tooltip,
    subtitle = false,
    label = false,
    icon = true,
    white = false,
    children
  } = props;

  const [uuid] = useState(crypto.randomUUID());

  if (!tooltip) {
    return children || null;
  }

  if (!icon) {
    return (
      <>
        <div data-tooltip-id={uuid}>
          {children}
        </div>
        <ReactTooltip
          id={uuid}
          className={classNames(
            'tooltip-custom-theme',
            _.isString(tooltip) && 'max-w-xs'
          )}
          variant="light"
          middlewares={tooltipMiddlewares}
        >
          {_.isString(tooltip) ? (
            <div className={classNames(
              // 'text-base',
              'text-sm',
              white ? 'text-white' : 'text-cs-gray-700'
            )}>
              {tooltip}
            </div>
          ) : tooltip}
        </ReactTooltip>
      </>
    );
  }

  if (label) {
    return (
      <>
        <QuestionMarkCircleIcon
          data-tooltip-id={uuid}
          className={classNames(
            'h-5 w-5 cursor-pointer',
            white ? 'text-white' : 'text-cs-gray-500'
          )}
        />
        <ReactTooltip
          id={uuid}
          className={classNames(
            'tooltip-custom-theme',
            _.isString(tooltip) && 'max-w-xs'
          )}
          variant="light"
          middlewares={tooltipMiddlewares}
        >
          {_.isString(tooltip) ? (
            <div className={classNames(
              'text-base',
              white ? 'text-white' : 'text-cs-gray-500'
            )}>
              {tooltip}
            </div>
          ) : tooltip}
        </ReactTooltip>
      </>
    );
  }

  if (subtitle) {
    return (
      <>
        <QuestionMarkCircleIcon
          data-tooltip-id={uuid}
          className="h-6 w-6 text-cs-gray-500 cursor-pointer"
        />
        <ReactTooltip
          id={uuid}
          className={classNames(
            'tooltip-custom-theme',
            _.isString(tooltip) && 'max-w-xs'
          )}
          variant="light"
          middlewares={tooltipMiddlewares}
        >
          {_.isString(tooltip) ? (
            <div className={classNames(
              'text-base',
              white ? 'text-white' : 'text-cs-gray-500'
            )}>
              {tooltip}
            </div>
          ) : tooltip}
        </ReactTooltip>
      </>
    );
  }

  return (
    <>
      <QuestionMarkCircleIcon
        data-tooltip-id={uuid}
        className={classNames(
          'h-6 w-6 cursor-pointer',
          white ? 'text-white' : 'text-cs-gray-900'
        )}
      />
      <ReactTooltip
        id={uuid}
        className={classNames(
          'tooltip-custom-theme',
          _.isString(tooltip) && 'max-w-xs'
        )}
        variant="light"
      >
        {_.isString(tooltip) ? (
          <div className={classNames(
            'text-base',
            white ? 'text-white' : 'text-cs-gray-500'
          )}>
            {tooltip}
          </div>
        ) : tooltip}
      </ReactTooltip>
    </>
  );
}

Tooltip.propTypes = {
  tooltip: PropTypes.node,
  subtitle: PropTypes.bool,
  label: PropTypes.bool,
  icon: PropTypes.bool,
  white: PropTypes.bool,
  children: PropTypes.node
};
